const operationPersonReport = {};

import {ORGANIZATION_SERVER} from '../server'
import {athubAxios} from "@/util";

operationPersonReport.exportExcel = (athubConfig) => {
    athubAxios.download(`${ORGANIZATION_SERVER}/operation/person/report/excel`, '运维管理中心人员清单.xlsx', athubConfig);
};

operationPersonReport.getReportData = (athubConfig) => {
    return athubAxios.get(`${ORGANIZATION_SERVER}/operation/person/report/data`, athubConfig);
};

export default operationPersonReport;